import { countEnabledStopPoints } from '@/utils/semi-auto/stop-points'

export default {
  getOpenRightPanelState: state => state.rightToolbarState > 52,
  getRightPanelWidthWithoutControls: state => state.rightToolbarState - 40,
  getIsStartPointVisible: state => state.isStartPointVisible,
  getIsGlobalClusterSelected: state => state.isGlobalClusterSelected,
  getOpenedAggregatedEdge: state => state.openedAggregatedEdge,
  allCurrencyList: state => (state.currencyList || []).concat(state.essentialCurrencyList || []),
  enabledStopPointsCount: state => countEnabledStopPoints(state.stopPoints),
  isSemiAutoRunning: state => Boolean(state.semiAutoStatus),
}
